// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"723f7c61","45":"6ff75582","250":"95698b39","748":"8897faf9","806":"cb67879a","868":"a456db0b"}[chunkId] + ".chunk.js";
};